import { cloneDeep } from 'lodash';
import FileDeliveryService from '../../apiclients/FileDeliveryService';
import ContentService from '../../apiclients/ContentService';

class BreadcrumbsController {
    constructor() {
        this.retryCounter = 0;
        this.maxRetry = 10;
    }

    loadBaseData = (currContentId, inside, currBreadcrumbs) => {
        let contentId = cloneDeep(currContentId);
        let oldContentId = cloneDeep(currContentId);
        if (!contentId) {
            contentId = '';
        }
        let breadcrumbs = [];
        return this.getCategory(contentId, currBreadcrumbs, breadcrumbs, true, inside).then((data) => {
            breadcrumbs = breadcrumbs.reverse();
            return { breadcrumbs, oldContentId };
        });
    }

    //NOTE: posar maxim 10 de profunditat
    getCategory = (contentId, currBreadcrumbs, breadcrumbs, isFirst, inside) => {
        let request;
        if (inside) {
            request = FileDeliveryService.getContent(
                contentId
            );
        } else {
            request = ContentService.getContent(
                contentId
            );
        }

        return request.then((data) => {
            if (isFirst) {
                let containsBreadcrumb = this.containsBreadcrumbId(currBreadcrumbs, data.contentId);
                if (containsBreadcrumb !== -1) {
                    breadcrumbs = this.cleanBreadcrumbsAndAdd(currBreadcrumbs, containsBreadcrumb, undefined, breadcrumbs);
                } else {
                    breadcrumbs.push(data);
                    const ancestors = data.ancestors;
                    if (ancestors && ancestors.length !== 0) {
                        let containsAnyAncestor = this.containsAnyAncestor(currBreadcrumbs, data.ancestors);
                        if (containsAnyAncestor !== -1) {
                            breadcrumbs = this.cleanBreadcrumbsAndAdd(currBreadcrumbs, containsAnyAncestor, data, breadcrumbs);
                        } else {
                            return this.getCategory(ancestors[0], currBreadcrumbs, breadcrumbs, false, inside);
                        }
                    }
                }
            } else {
                breadcrumbs.push(data);
                const ancestors = data.ancestors;
                if (ancestors && ancestors.length !== 0) {
                    return this.getCategory(ancestors[0], currBreadcrumbs, breadcrumbs, false, inside);
                }
            }
        }).catch((err) => {
            console.log(err.message);
            if (this.retryCounter < this.maxRetry) {
                this.retryCounter++;
                return this.loadBaseData();
            }
        });
    }

    cleanBreadcrumbsAndAdd = (currBreadcrumbs, existingIndex, element, newBreadcrumbs) => {
        if (existingIndex !== -1) {
            newBreadcrumbs.splice(0, newBreadcrumbs.length);
            let breadcrumbs = cloneDeep(currBreadcrumbs);
            breadcrumbs = breadcrumbs.slice(0, existingIndex + 1);
            breadcrumbs = breadcrumbs.reverse();
            if (element) {
                newBreadcrumbs.push(element);
            }
            for (let i = 0; i < breadcrumbs.length; i++) {
                newBreadcrumbs.push(breadcrumbs[i]);
            }
        }
    }

    containsAnyAncestor = (currBreadcrumbs, ancestors) => {
        let breadcrumbs = currBreadcrumbs;
        if (breadcrumbs) {
            for (let i = 0; i < ancestors.length; i++) {
                let ancestor = ancestors[i];
                let containsBreadcrumbId = this.containsBreadcrumbId(currBreadcrumbs, ancestor);
                if (containsBreadcrumbId !== -1) {
                    return containsBreadcrumbId;
                }
            }
        }
        return -1;
    }

    containsBreadcrumbId = (currBreadcrumbs, breadcrumbId) => {
        let breadcrumbs = currBreadcrumbs;
        if (breadcrumbs) {
            for (let i = 0; i < breadcrumbs.length; i++) {
                if (breadcrumbs[i].contentId === breadcrumbId) {
                    return i;
                }
            }
        }
        return -1;
    }
}
export default BreadcrumbsController;